import { render } from "./AddToCartButtonComponent.vue?vue&type=template&id=4a7cd39a&scoped=true"
import script from "./AddToCartButtonComponent.vue?vue&type=script&lang=js"
export * from "./AddToCartButtonComponent.vue?vue&type=script&lang=js"

import "./AddToCartButtonComponent.vue?vue&type=style&index=0&id=4a7cd39a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a7cd39a"]])

export default __exports__